<template>
  <div
    class="blog store-blog-post post"
    :class="{
      'teemill-atlas': app && !app.isSubdomain,
      subdomain: app && app.isSubdomain,
      'logged-out-mobile': isLoggedOutMobile,
    }"
  >
    <div class="mb-6">
      <h1 class="mb-2">
        {{ post.title }}
      </h1>

      <div v-if="commentCount !== null">
        <tml-anchor class="bold" @click="$emit('click-comment-count')">
          <font-awesome-icon class="mr-2" :icon="faComment" />
          <span v-if="commentCount === 0">View Comments</span>
          <span v-else>
            {{ commentCount }}
            {{ commentCount === 1 ? 'New Comment' : 'New Comments' }}
          </span>
        </tml-anchor>
      </div>
    </div>

    <div class="content" v-html="displayedContent" />

    <blog-tag-list class="mt-8 mb-6" :tags="post.tags" width="narrow" />

    <hr />
    <h4>Sharing is caring</h4>
    <tml-share-buttons
      :icon-set="['facebook', 'twitter', 'email', 'copyUrl']"
    />

    <slot name="footer" />
  </div>
</template>

<script>
import {isLoggedOut} from '@teemill/common/guards';
import {faComment} from '@fortawesome/pro-regular-svg-icons';
import BlogTagList from './BlogTagList.vue';
import {maxDevice} from '@teemill/common/helpers';

export default {
  name: 'DisplayPost',

  components: {
    BlogTagList,
  },

  inject: ['app'],

  props: {
    post: {
      type: Object,
      required: true,
    },

    commentCount: {
      type: Number,
    },
  },

  data() {
    return {
      meta: {},
      faComment,
    };
  },

  computed: {
    isLoggedOutMobile() {
      return maxDevice('md') && this.app.isTeemill && isLoggedOut.passes;
    },

    displayedContent() {
      return this.post.content
        .replace(/<img src=/g, '<img class="lazyload" data-src=')
        .replace(/\?w=1140/g, '?w=680')
        .replace('<img class="lazyload" data-src=', '<img src=');
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/scss/display.scss';

.logged-out-mobile {
  padding-top: 3rem;
}
</style>
